import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { canAccessAdmin } from "../lib/config";

const MGMT_LINKS = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/work-orders", label: "Work Orders" },
  { to: "/inventory", label: "Inventory" },
  { to: "/leads", label: "Prospective Tenants" },
  { to: "/units", label: "Units" },
  { to: "/tenants", label: "Tenants" },
  { to: "/incidents", label: "Incidents" },
  { to: "/alerts", label: "Alerts" },
];

const MAINT_LINKS = [
  { to: "/maintenance", label: "My Work Orders" },
  { to: "/maintenance/calendar", label: "Calendar" },
  { to: "/alerts", label: "Alerts" },
  { to: "/account", label: "Account" },
];

export function Sidebar() {
  const { user } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  if (!user) return null;

  const isMaintenance = user.role === "maintenance";
  const links = isMaintenance ? MAINT_LINKS : [...MGMT_LINKS];
  if (!isMaintenance && canAccessAdmin(user.role)) {
    links.push({ to: "/admin", label: "Admin" });
  }

  return (
    <aside className={"sidebar" + (mobileOpen ? " mobile-open" : "")}>
      <div className="brand">
        <div className="logo">RH</div>
        <div>
          <strong>Royal Heights</strong>
          <span>{isMaintenance ? "Maintenance" : "Property Management"}</span>
        </div>
        <button
          type="button"
          className="mobile-menu-toggle"
          onClick={() => setMobileOpen((open) => !open)}
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
          aria-controls="primary-navigation"
          title={mobileOpen ? "Close menu" : "Open menu"}
        >
          <span aria-hidden="true">{mobileOpen ? "\u00d7" : "\u2630"}</span>
        </button>
      </div>
      <nav id="primary-navigation">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/maintenance"}
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
            aria-current={undefined}
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
